import React from 'react';
import {WrapperButtonsRedirect} from "./styled.jsx";
import PropTypes from "prop-types";
import { defaultTheme } from '../../globalStyleds.js';
import { useTranslation } from 'react-i18next';

const buttonStyleMap = {
  light: 'btn--black',
  dark: 'btn--white',
};

/**
 * Actions component
 */
export const Actions = ({ backMerchant = null, buttonLabel = null, merchant = null, theme = null }) => {
  const { t } = useTranslation();
  const errorBack = t('error.generic.back');
  const errorMerchant = t('common.merchant');
  const themeName = theme?.name || theme?.palette?.mode || defaultTheme;

  return (
    <WrapperButtonsRedirect>
      <button onClick={backMerchant} className={buttonStyleMap[themeName] }>
        {buttonLabel || `${errorBack} ${merchant || errorMerchant}`}
      </button>
    </WrapperButtonsRedirect>
  );
};
Actions.propTypes = {
  /**
   * What handle direct Merchant URL
   */
  buttonLabel: PropTypes.string,
  backMerchant: PropTypes.func,
  merchant: PropTypes.string,
  theme: PropTypes.object,
};

